import { createFileRoute } from "@tanstack/react-router";
import { InsightsPage } from "@/features/settings/insights-page";

export const Route = createFileRoute("/_app/settings/insights")({ component: InsightsPage });
